import Vue from 'vue';
import confirm from './Morconfirm.vue';
import common from "../../js/common.js";
/*    
 *   @parmam settingObj  基本展示信息配置
 *   @parmam morclick 内容点击事件的回调
 *   @parmam resolve 底部按钮点击回调
 *   @parmam reject 底部按钮点击回调
 * 
 *   @parmam  title  标题
 *   @parmam  content  内容
 *   @parmam  mtype  提示框类型
 *   @parmam  clickContent  内容2
 *   
*/
let confirmConstructor = Vue.extend(confirm);
let morConfirm = function (settingObj, morclick) {
    return new Promise((resolve, reject) => {
        const domId = 'morconfirm';
        const mountEle = document.createElement("div");
        mountEle.id = domId
        document.body.appendChild(mountEle);
        let confirmDom = new confirmConstructor({
        }).$mount('#' + domId)
        let marignSettingObj = {};
        if (settingObj == undefined || Object.keys(settingObj).length === 0) {
            // 没有传入参数,赋值默认值
            marignSettingObj = {
                title: '导入',
                content: '导入成功',
                mtype: common.Constant.MORCONFIRMTYPE.MORCONFIRMSUCCESS,
                btn: ['确定']
            }
        } else {
            // 有参数传入
            marignSettingObj = settingObj;
            if (!marignSettingObj.hasOwnProperty('title')) {
                marignSettingObj.title = '导入';
            }
            if (!marignSettingObj.hasOwnProperty('content')) {
                marignSettingObj.content = '导入成功';
            }
            if (!marignSettingObj.hasOwnProperty('btn')) {
                marignSettingObj.btn = ['确定'];
            }
            if (!marignSettingObj.hasOwnProperty('mtype')) {
                marignSettingObj.mtype = common.Constant.MORCONFIRMTYPE.MORCONFIRMSUCCESS;
            }
            if (!marignSettingObj.hasOwnProperty('clickContent') && marignSettingObj.mtype == common.Constant.MORCONFIRMTYPE.MORCONFIRMCOMPLETE) {
                marignSettingObj.clickContent = '点击前往导入历史数据 >>'
            }
        }
        confirmDom.settingObj = marignSettingObj;
        // 执行函数并在使用的地方回调
        confirmDom.morconfirm = function () {
            resolve();
            confirmDom.isShow = false;
        }
        confirmDom.morcancel = function () {
            reject();
            confirmDom.isShow = false;
        }
        confirmDom.morgoto = function () {
            morclick();
            confirmDom.isShow = false;
        }
    })
}
export default morConfirm; 
